import React from "react";
import AttendanceRecordsList from "./records-list";
import { useAuth } from "../../provider/auth.provider";
import { FiLock } from "react-icons/fi";

const MyAttendancesPage: React.FC = () => {
  const { hasPermission } = useAuth();

  if (!hasPermission('attendance', 'view_my')) {
    return (
      <div className="min-h-[300px] flex items-center justify-center">
        <div className="text-center">
          <FiLock className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <h3 className="text-base font-semibold text-gray-700">Access Denied</h3>
          <p className="text-sm text-gray-500 mt-1">You do not have permission to view your attendance records.</p>
        </div>
      </div>
    );
  }

  return (
    <AttendanceRecordsList
      scope="my"
      endpoint="/attendance/my"
      title="My Attendances"
      description="View your attendance records."
    />
  );
};

export default MyAttendancesPage;
